import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PermissionHelper } from '../../../../shared/helpers/permission.helper';
import { DevelopmentTask } from '../../../../shared/models/development-task.model';
import { OrderService } from '../../../../order/order.service';
import { MessageService } from '../../../../shared/services/message.service';

@Component({
  standalone: false,
  selector: 'app-add-development-operation-modal',
  templateUrl: './add-development-operation.component.html',
  styleUrls: ['../modal.component.scss']
})
export class AddDevelopmentOperationModalComponent implements OnInit {
  @Input() operation:  DevelopmentTask;
  developmentOperationNames: Array<string> = [];
  operationForm: FormGroup;
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private fb: FormBuilder,
              public permissionHelper: PermissionHelper,
              private orderService: OrderService,
              private message: MessageService) { }

  ngOnInit(): void {
    this.initForm();
    this.getDevelopmentOperations();

    if (this.operation) {
      this.operationForm.patchValue(this.operation);
    }
  }

  getDevelopmentOperations(): void {
    this.orderService.getDevelopmentJobOperations().subscribe(
      res => {
        this.developmentOperationNames = res.results;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  initForm(): void {
    this.operationForm = this.fb.group({
      name: ['', Validators.required],
      timeEstimatedEmployee: null,
      comment: ''
    });
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }

  emitTrue(): void {
    this.responseChanged.emit(this.operationForm.value);
  }
}